import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getBRSListReq = (action) => {
    const { societyId, fin_year, account_cd, status, page, limit } = action?.data || {};
    const url = apiEndpoints.GET_BRS_LIST_API.replace(':societyId', societyId);
    const params = {};
    if (fin_year) params.fin_year = fin_year;
    if (account_cd) params.account_cd = account_cd;
    if (status && status !== 'all') params.status = status;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    return axiosInstance.get(url, { params });
}

export const getBRSDetailsReq = (action) => {
    const { societyId, brsId } = action?.data || {};
    const url = apiEndpoints.GET_BRS_DETAILS_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.get(url);
}

export const createBRSReq = (action) => {
    const { societyId, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.CREATE_BRS_API.replace(':societyId', societyId);
    return axiosInstance.post(url, payload);
}

export const updateBRSReq = (action) => {
    const { societyId, brsId, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.UPDATE_BRS_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.put(url, payload);
}

export const finalizeBRSReq = (action) => {
    const { societyId, brsId } = action?.data || {};
    const url = apiEndpoints.FINALIZE_BRS_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.put(url, {});
}

export const deleteBRSReq = (action) => {
    const { societyId, brsId } = action?.data || {};
    const url = apiEndpoints.DELETE_BRS_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.delete(url);
}

export const clearBRSEntriesReq = (action) => {
    const { societyId, brsId, entries } = action?.data || {};
    const url = apiEndpoints.CLEAR_BRS_ENTRIES_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.post(url, { entries });
}

export const importBRSStatementReq = (action) => {
    const { societyId, brsId, rows } = action?.data || {};
    const url = apiEndpoints.IMPORT_BRS_STATEMENT_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.post(url, { rows });
}

export const autoMatchBRSReq = (action) => {
    const { societyId, brsId } = action?.data || {};
    const url = apiEndpoints.AUTO_MATCH_BRS_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.post(url, {});
}

export const manualMatchBRSReq = (action) => {
    const { societyId, brsId, snapshot_id, statement_id } = action?.data || {};
    const url = apiEndpoints.MANUAL_MATCH_BRS_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.post(url, { snapshot_id, statement_id });
}

export const unmatchBRSReq = (action) => {
    const { societyId, brsId, snapshot_id } = action?.data || {};
    const url = apiEndpoints.UNMATCH_BRS_API
        .replace(':societyId', societyId)
        .replace(':brsId', brsId);
    return axiosInstance.post(url, { snapshot_id });
}
